import { useEffect, useState } from "react";
import {
  canInstallApp,
  isRunningStandalone,
  promptInstall,
  subscribeInstallAvailability,
} from "@/lib/pwa";

/**
 * Renders an "Install App" button when the browser has fired the
 * `beforeinstallprompt` event and the app is not already running in
 * standalone (installed) mode. Returns null otherwise so the TopBar
 * stays compact on desktops that don't support PWA install.
 */
export function InstallPromptButton() {
  const [visible, setVisible] = useState(canInstallApp());
  const [pending, setPending] = useState(false);

  useEffect(() => {
    if (isRunningStandalone()) {
      setVisible(false);
      return;
    }
    return subscribeInstallAvailability(setVisible);
  }, []);

  if (!visible) return null;

  async function handleClick() {
    setPending(true);
    try {
      await promptInstall();
    } finally {
      setPending(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={pending}
      className="px-3 py-1.5 text-xs font-body rounded-dw-sm border border-dw-blue text-dw-blue hover:bg-dw-blue-soft disabled:opacity-50 transition-colors whitespace-nowrap"
      aria-label="Install Recovery Console as an app"
    >
      Install App
    </button>
  );
}
